export const PointsEndpoints = {
    balance: (doneeId: number) => `/donees/${doneeId}/points/balance`,
    withdrawalsHistory: (givingPartnerId: number, page: number) =>
        `/donees/${givingPartnerId}/points/withdrawals?page=${page}`,
    donationInformation: (
        doneeId: number,
        donorId: number,
        donationId: number,
    ) => `/donees/${doneeId}/donors/${donorId}/donations/${donationId}`,
    withdraw: (doneeId: number) => `/donees/${doneeId}/points/withdrawals`,
    settings: (doneeId: number) => `/donees/${doneeId}/points/settings`,
    calculate: (doneeId: number) =>
        `/donees/${doneeId}/points/withdrawals/calculate`,
};
